/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */
import { faker } from '@faker-js/faker';
import type { RequestHandlerOptions } from 'msw';
import { delay, HttpResponse, http } from 'msw';
import type {
  EucImportCreateResponse,
  EucImportResultDetailResponse,
  EucImportResultOptionsResponse,
  EucImportValidateResponse,
  PagedEucImportResultExpendituresResponse,
  PagedEucImportResultRevenueAppropriationsResponse,
  PagedEucImportResultRevenuesResponse,
  PagedEucImportResultsResponse,
  SuccessResponse,
} from './model';
import { EucAmountUnit, EucDataType, EucImportStatus, EucImportValidateStatus } from './model';

export const getGetEucImportResultsResponseMock = (): PagedEucImportResultsResponse => ({
  ...{ count: faker.number.int({ min: undefined, max: undefined }) },
  ...{
    items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
      () => ({
        id: faker.string.uuid(),
        title: faker.string.alpha({ length: { min: 1, max: 255 } }),
        euc_data_type: faker.helpers.arrayElement(Object.values(EucDataType)),
        fiscal_year: faker.number.int({ min: 1900, max: 2100 }),
        status: faker.helpers.arrayElement(Object.values(EucImportStatus)),
        import_started_at: faker.helpers.arrayElement([
          `${faker.date.past().toISOString().split('.')[0]}Z`,
          null,
        ]),
        import_completed_at: faker.helpers.arrayElement([
          faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, null]),
          undefined,
        ]),
        file_name: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 255 } }), null]),
          undefined,
        ]),
        description: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
          undefined,
        ]),
        imported_by_id: faker.string.uuid(),
        usable_for_settlement_statistics_converter_training: faker.datatype.boolean(),
      }),
    ),
  },
});

export const getGetEucImportOptionsResponseMock = (): EucImportResultOptionsResponse => ({
  accounting_types: [{ code: '01', name: '一般会計' }],
  organization_codes: [{ code: '01', name: '組織01' }],
  expenditure_purpose_code_combinations: [
    {
      parent_accounting_type_code: '01',
      kan_code: '01',
      kan_name: '款01',
      ko_code: '01',
      ko_name: '項01',
      moku_code: '01',
      moku_name: '目01',
    },
  ],
  expenditure_nature_code_combinations: [
    {
      setsu_code: '01',
      setsu_name: '節01',
      saisetsu_code: '01',
      saisetsu_name: '細節01',
      saisaisetsu_code: '01',
      saisaisetsu_name: '細々節01',
    },
  ],
  revenue_nature_code_combinations: [
    {
      parent_accounting_type_code: '01',
      kan_code: '01',
      kan_name: '款01',
      ko_code: '01',
      ko_name: '項01',
      moku_code: '01',
      moku_name: '目01',
      setsu_code: '01',
      setsu_name: '節01',
      saisetsu_code: '01',
      saisetsu_name: '細節01',
      saisaisetsu_code: '01',
      saisaisetsu_name: '細々節01',
    },
  ],
});

export const getGetEucImportResultExpendituresResponseMock =
  (): PagedEucImportResultExpendituresResponse => ({
    ...{ count: faker.number.int({ min: undefined, max: undefined }) },
    ...{
      items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
        () => ({
          id: faker.string.uuid(),
          fiscal_year: faker.number.int({ min: 1900, max: 2100 }),
          organization_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          organization_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          accounting_type_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          accounting_type_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          kan_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          kan_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          ko_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          ko_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          moku_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          moku_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          setsu_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          setsu_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          saisetsu_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          saisetsu_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          saisaisetsu_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          saisaisetsu_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          project_category1_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          project_category1_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          project_category2_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          project_category2_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          project_category3_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          project_category3_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          project_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          project_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          project_overview: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          description: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          amount: faker.number.int({ min: undefined, max: undefined }),
          settlement_purpose1_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose1_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose2_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose2_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose3_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose3_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose4_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose4_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_nature1_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_nature1_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_nature2_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_nature2_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_nature3_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_nature3_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_nature4_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_nature4_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          recurring_type: faker.string.alpha({ length: { min: 10, max: 20 } }),
          funding_type: faker.string.alpha({ length: { min: 10, max: 20 } }),
        }),
      ),
    },
  });

export const getGetEucImportResultRevenuesResponseMock =
  (): PagedEucImportResultRevenuesResponse => ({
    ...{ count: faker.number.int({ min: undefined, max: undefined }) },
    ...{
      items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
        () => ({
          id: faker.string.uuid(),
          fiscal_year: faker.number.int({ min: 1900, max: 2100 }),
          organization_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          organization_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          accounting_type_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          accounting_type_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          kan_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          kan_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          ko_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          ko_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          moku_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          moku_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          setsu_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          setsu_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          saisetsu_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          saisetsu_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          saisaisetsu_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          saisaisetsu_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          description: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          amount: faker.number.int({ min: undefined, max: undefined }),
          settlement_purpose1_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose1_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose2_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose2_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose3_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose3_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose4_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose4_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          recurring_type: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          revenue_source_type: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
        }),
      ),
    },
  });

export const getGetEucImportResultRevenueAppropriationsResponseMock =
  (): PagedEucImportResultRevenueAppropriationsResponse => ({
    ...{ count: faker.number.int({ min: undefined, max: undefined }) },
    ...{
      items: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
        () => ({
          id: faker.string.uuid(),
          fiscal_year: faker.number.int({ min: 1900, max: 2100 }),
          accounting_type_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          accounting_type_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          expenditure_kan_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          expenditure_kan_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          expenditure_ko_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          expenditure_ko_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          expenditure_moku_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          expenditure_moku_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          project_category1_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          project_category1_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          project_category2_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          project_category2_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          project_category3_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          project_category3_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          project_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          project_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          settlement_purpose1_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose1_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose2_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose2_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose3_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose3_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose4_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_purpose4_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_nature1_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_nature1_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_nature2_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_nature2_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_nature3_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_nature3_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_nature4_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          settlement_nature4_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          expenditure_recurring_type: faker.string.alpha({ length: { min: 10, max: 20 } }),
          expenditure_funding_type: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_organization_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_organization_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_kan_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_kan_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_ko_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_ko_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_moku_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_moku_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_setsu_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_setsu_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_saisetsu_code: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_saisetsu_name: faker.string.alpha({ length: { min: 10, max: 20 } }),
          revenue_saisaisetsu_code: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          revenue_saisaisetsu_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          revenue_appropriation_amount: faker.number.int({ min: undefined, max: undefined }),
        }),
      ),
    },
  });

export const getCreateEucImportResponseMock = (): EucImportCreateResponse => ({
  id: 'e0c00003-0000-0000-0000-000000000001',
  url: 'https://s3.ap-northeast-1.amazonaws.com/bucket',
  object_key:
    'euc/expenditure-record/00000001-0000-0000-0000-000000000001/e0c00003-0000-0000-0000-000000000001',
  fields: {
    key: 'euc/expenditure-record/00000001-0000-0000-0000-000000000001/e0c00003-0000-0000-0000-000000000001',
    'Content-Type': 'text/csv',
    policy: 'eyJleHBpcmF0aW9uIjoi...',
    'x-amz-algorithm': 'AWS4-HMAC-SHA256',
    'x-amz-credential': 'AKIAIOSFODNN7EXAMPLE/20250109/ap-northeast-1/s3/aws4_request',
    'x-amz-date': '20250109T000000Z',
    'x-amz-signature': 'abcdef1234567890...',
  },
});

export const getValidateEucImportResponseMock = (
  overrideResponse: Partial<EucImportValidateResponse> = {},
): EucImportValidateResponse => ({
  id: faker.string.uuid(),
  status: faker.helpers.arrayElement(Object.values(EucImportValidateStatus)),
  error_details: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(
    () => ({
      row_index: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
        undefined,
      ]),
      column_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
        undefined,
      ]),
      value: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
        undefined,
      ]),
      error_message: faker.string.alpha({ length: { min: 10, max: 20 } }),
    }),
  ),
  warning_details: {
    settlement_statistics: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      row_index: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
        undefined,
      ]),
      column_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
        undefined,
      ]),
      value: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
        undefined,
      ]),
      warning_message: faker.string.alpha({ length: { min: 10, max: 20 } }),
    })),
  },
  error_traceback: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
    undefined,
  ]),
  can_import_with_preprocessor: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  preprocessor_column_mappings: faker.helpers.arrayElement([
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      csv_column: faker.string.alpha({ length: { min: 10, max: 20 } }),
      target_column: faker.string.alpha({ length: { min: 10, max: 20 } }),
    })),
    undefined,
  ]),
  error_details_with_preprocessor: faker.helpers.arrayElement([
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      row_index: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
        undefined,
      ]),
      column_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
        undefined,
      ]),
      value: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
        undefined,
      ]),
      error_message: faker.string.alpha({ length: { min: 10, max: 20 } }),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getExecuteEucImportResponseMock = (): SuccessResponse => ({ success: true });

export const getGetEucImportResultResponseMock = (
  overrideResponse: Partial<EucImportResultDetailResponse> = {},
): EucImportResultDetailResponse => ({
  id: faker.string.uuid(),
  title: faker.string.alpha({ length: { min: 10, max: 20 } }),
  euc_data_type: faker.helpers.arrayElement(Object.values(EucDataType)),
  fiscal_year: faker.number.int({ min: 1900, max: 2100 }),
  amount_unit: faker.helpers.arrayElement(Object.values(EucAmountUnit)),
  status: faker.helpers.arrayElement(Object.values(EucImportStatus)),
  import_started_at: faker.helpers.arrayElement([
    faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, null]),
    undefined,
  ]),
  import_completed_at: faker.helpers.arrayElement([
    faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, null]),
    undefined,
  ]),
  file_name: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 255 } }), null]),
    undefined,
  ]),
  description: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
    undefined,
  ]),
  error_details: faker.helpers.arrayElement([
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      row_index: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
        undefined,
      ]),
      column_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
        undefined,
      ]),
      value: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
        undefined,
      ]),
      error_message: faker.string.alpha({ length: { min: 10, max: 20 } }),
    })),
    undefined,
  ]),
  error_details_with_preprocessor: faker.helpers.arrayElement([
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      row_index: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), null]),
        undefined,
      ]),
      column_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
        undefined,
      ]),
      value: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), null]),
        undefined,
      ]),
      error_message: faker.string.alpha({ length: { min: 10, max: 20 } }),
    })),
    undefined,
  ]),
  usable_for_settlement_statistics_converter_training: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getDeleteEucImportResponseMock = (): SuccessResponse => ({ success: true });

export const getGetEucImportResultsMockHandler = (
  overrideResponse?:
    | PagedEucImportResultsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<PagedEucImportResultsResponse> | PagedEucImportResultsResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/euc/import-results',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetEucImportResultsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetEucImportOptionsMockHandler = (
  overrideResponse?:
    | EucImportResultOptionsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<EucImportResultOptionsResponse> | EucImportResultOptionsResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/euc/imports/:eucImportId/options',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetEucImportOptionsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetEucImportResultExpendituresMockHandler = (
  overrideResponse?:
    | PagedEucImportResultExpendituresResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<PagedEucImportResultExpendituresResponse>
        | PagedEucImportResultExpendituresResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/euc/import-results/:eucImportId/expenditures',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetEucImportResultExpendituresResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetEucImportResultRevenuesMockHandler = (
  overrideResponse?:
    | PagedEucImportResultRevenuesResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<PagedEucImportResultRevenuesResponse> | PagedEucImportResultRevenuesResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/euc/import-results/:eucImportId/revenues',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetEucImportResultRevenuesResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetEucImportResultRevenueAppropriationsMockHandler = (
  overrideResponse?:
    | PagedEucImportResultRevenueAppropriationsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<PagedEucImportResultRevenueAppropriationsResponse>
        | PagedEucImportResultRevenueAppropriationsResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/euc/import-results/:eucImportId/revenue-appropriations',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetEucImportResultRevenueAppropriationsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateEucImportMockHandler = (
  overrideResponse?:
    | EucImportCreateResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<EucImportCreateResponse> | EucImportCreateResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/euc/imports',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateEucImportResponseMock(),
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getValidateEucImportMockHandler = (
  overrideResponse?:
    | EucImportValidateResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<EucImportValidateResponse> | EucImportValidateResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/euc/imports/:eucImportId/validate',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getValidateEucImportResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getExecuteEucImportMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/euc/imports/:eucImportId/execute',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getExecuteEucImportResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetEucImportResultMockHandler = (
  overrideResponse?:
    | EucImportResultDetailResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<EucImportResultDetailResponse> | EucImportResultDetailResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/euc/imports/:eucImportId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetEucImportResultResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getDeleteEucImportMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.delete(
    '*/euc/imports/:eucImportId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteEucImportResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};
export const getDnRAPIMock = () => [
  getGetEucImportResultsMockHandler(),
  getGetEucImportOptionsMockHandler(),
  getGetEucImportResultExpendituresMockHandler(),
  getGetEucImportResultRevenuesMockHandler(),
  getGetEucImportResultRevenueAppropriationsMockHandler(),
  getCreateEucImportMockHandler(),
  getValidateEucImportMockHandler(),
  getExecuteEucImportMockHandler(),
  getGetEucImportResultMockHandler(),
  getDeleteEucImportMockHandler(),
];
